import React from 'react';
import { Box, Button, Grid, Paper, Typography, makeStyles } from '@material-ui/core';
import UnitsVehiclesBlock from './VehiclesBlock';

const SECTION_ACCENT = '#003E7E';

const useStyles = makeStyles(() => ({
  sectionTitle: {
    color: SECTION_ACCENT,
    fontSize: '1.125rem',
    fontWeight: 500,
    lineHeight: 1.2,
  },
  addButton: {
    backgroundColor: SECTION_ACCENT,
    color: '#fff',
    borderColor: SECTION_ACCENT,
    paddingTop: 6,
    paddingBottom: 6,
    '&:hover': {
      backgroundColor: '#003266',
      borderColor: '#003266',
    },
  },
}));

const VehiclesSection = ({
  title,
  vehicleTitle,
  type,
  buttonId,
  addButtonText,
  addButtonHandler,
  vehicles,
  control,
  register,
  fieldErrors,
  deleteButtonHandler,
  watch,
  getValues,
  formErrors,
  setValue,
  showActions,
  submitDisabled,
  onSavePermit,
  onCancelPermit,
  isUnitLoaded,
  vehiclesRevision = 0,
}) => {
  const classes = useStyles();
  const isVehicleRecord = (item) =>
    item && typeof item === 'object' && !Array.isArray(item);
  let vehicleNumber = 0;

  return (
    <>
      <Paper elevation={0} variant="outlined">
        <Box
          px={2}
          py={1.5}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6" className={classes.sectionTitle}>
            {title}
          </Typography>
          {showActions ? (
            <Button
              id={buttonId}
              variant="contained"
              size="medium"
              className={classes.addButton}
              onClick={addButtonHandler}
              disabled={submitDisabled}
            >
              {addButtonText}
            </Button>
          ) : null}
        </Box>
        {vehicles.length ? (
          <Box px={2} pb={2}>
            <Grid container spacing={2}>
              {vehicles.map((item, index) => {
                if (item === undefined) {
                  return null;
                }

                const cardNumber = ++vehicleNumber;
                const slotKey = item?.id
                  ? `${type}-permit-${item.id}`
                  : `${type}-empty-${vehiclesRevision}-${index}`;

                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={slotKey}
                  >
                    <Paper
                      variant="outlined"
                      style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <UnitsVehiclesBlock
                        fieldId={buttonId}
                        vehicleIndex={index}
                        vehicleNumber={cardNumber}
                        vehicleTitle={vehicleTitle}
                        type={type}
                        vehicle={isVehicleRecord(item) ? item : null}
                        control={control}
                        register={register}
                        fieldErrors={fieldErrors}
                        deleteButtonHandler={deleteButtonHandler}
                        watch={watch}
                        getValues={getValues}
                        formErrors={formErrors}
                        setValue={setValue}
                        showActions={showActions}
                        submitDisabled={submitDisabled}
                        isUnitLoaded={isUnitLoaded}
                        onSave={() => onSavePermit(index)}
                        onCancel={() => onCancelPermit(index)}
                      />
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        ) : null}
      </Paper>
      <Box mb={2} />
    </>
  );
};

export default VehiclesSection;
